import constants from "./constants";

export default {
  Debtors: {
    displayName: 'Debtors',
    iconClass: 'fa-user',
    field: 'DebtorList',
    endpoint: 'Debtors',
    path: 'debtors',
    productFamily: constants.PRODUCT_FAMILY.CTM
  },
  Settings: {
    displayName: 'Settings',
    iconClass: 'fa-cog',
    field: 'SettingsResource',
    path: 'settings',
    productFamily: constants.PRODUCT_FAMILY.CTM
  },
  CreditCards: {
    displayName: 'Credit Cards',
    iconClass: 'fa-credit-card',
    field: 'CreditCardsList',
    endpoint: 'CreditCards',
    path: 'credit-cards',
    productFamily: constants.PRODUCT_FAMILY.CTM
  },
  PointsOfInterest: {
    displayName: 'Points of Interest',
    iconClass: 'fa-map-marker',
    field: 'PointsOfInterestList',
    path: 'points-of-interest',
    endpoint: '',
    productFamily: constants.PRODUCT_FAMILY.CTM
  },
  AirlineCarriers: {
    displayName: 'Airline Carriers',
    iconClass: 'fa-plane',
    field: 'AirlineCarriersList',
    endpoint: 'AirlineCarriers',
    path: 'airline-carriers',
    productFamily: constants.PRODUCT_FAMILY.AIR
  },
  Airports: {
    displayName: 'Airports',
    iconClass: 'fa-plane',
    field: 'AirportsList',
    endpoint: 'Airports',
    path: 'airports',
    productFamily: constants.PRODUCT_FAMILY.AIR
  },
  CarSuppliers: {
    displayName: 'Car Suppliers',
    iconClass: 'fa-car',
    field: 'CarSuppliersList',
    endpoint: 'CarSuppliers',
    path: 'car-suppliers',
    productFamily: constants.PRODUCT_FAMILY.VEHICLE
  },
  CarSupplierLocations: {
    displayName: 'Car Supplier Locations',
    iconClass: 'fa-car',
    field: 'CarSuppliersLocations',
    endpoint: 'CarSupplierLocations',
    path: 'car-supplier-locations',
    productFamily: constants.PRODUCT_FAMILY.VEHICLE
  },
  Vehicles: {
    displayName: 'Cars',
    iconClass: 'fa-car',
    field: 'VehiclesList',
    endpoint: 'Vehicles',
    path: 'cars',
    productFamily: constants.PRODUCT_FAMILY.VEHICLE
  },
  Hotels: {
    rootNode: true,
    displayName: 'Hotels',
    iconClass: 'fa-bed',
    field: 'HotelsList',
    path: 'hotels',
    endpoint: '',
    productFamily: constants.PRODUCT_FAMILY.HOTEL
  },
  HotelSupplierMembershipPrograms: {
    displayName: 'Hotel Suppliers',
    iconClass: 'fa-bed',
    field: 'HotelSupplierMembershipProgramsList',
    endpoint: 'HotelSupplierMembershipPrograms',
    path: 'hotel-suppliers',
    productFamily: constants.PRODUCT_FAMILY.HOTEL
  },
  RailSuppliers: {
    displayName: 'Rail Suppliers',
    iconClass: 'fa-train',
    field: 'RailSuppliersList',
    endpoint: 'RailSuppliers',
    path: 'rail-suppliers',
    productFamily: constants.PRODUCT_FAMILY.RAIL
  },
  RailStations: {
    displayName: 'Rail Stations',
    iconClass: 'fa-train',
    field: 'RailStationsList',
    endpoint: 'RailStations',
    path: 'rail-stations',
    productFamily: constants.PRODUCT_FAMILY.RAIL
  },
  RailCards: {
    displayName: 'Rail Cards',
    iconClass: 'fa-train',
    field: 'RailCardsList',
    endpoint: 'RailCards',
    path: 'rail-cards',
    productFamily: constants.PRODUCT_FAMILY.RAIL
  },
  CTMPortal: {
    displayName: 'CTM Portal',
    iconClass: 'fa-th',
    field: 'CtmPortalProductByDebtorList',
    endpoint: 'DebtorProducts',
    path: 'product/ctm-portal',
    productFamily: constants.PRODUCT_FAMILY.PRODUCTS
  },
  CTMMobile: {
    displayName: 'CTM Mobile',
    iconClass: 'fa-mobile',
    field: 'CtmMobileProductByDebtorList,',
    endpoint: 'DebtorProducts',
    path: 'product/ctm-mobile',
    productFamily: constants.PRODUCT_FAMILY.PRODUCTS
  },
  CTMApprove: {
    displayName: 'CTM Approve',
    iconClass: 'fa-thumbs-up',
    field: 'CtmApproveProductByDebtorList',
    endpoint: 'DebtorProducts',
    path: 'product/ctm-approve',
    productFamily: constants.PRODUCT_FAMILY.PRODUCTS
  },
  LightningBook: {
    displayName: 'Lightning Book',
    iconClass: 'fa-bolt',
    field: 'CtmLightningProductByDebtorList',
    endpoint: 'DebtorProducts',
    path: 'product/lightning-book',
    productFamily: constants.PRODUCT_FAMILY.PRODUCTS
  },
  HotelReviews: {
    displayName: 'Hotel Reviews',
    iconClass: 'fa-comments',
    field: 'HotelReviewsResource',
    endpoint: 'DebtorProducts',
    path: 'product/hotel-reviews',
    productFamily: constants.PRODUCT_FAMILY.PRODUCTS
  },
  RideShare: {
    displayName: 'Ride Share',
    iconClass: 'fa-taxi',
    field: 'CtmRideShareProductByDebtorList',
    endpoint: 'DebtorProducts',
    path: 'product/ride-share',
    productFamily: constants.PRODUCT_FAMILY.PRODUCTS
  },
  Risk: {
    displayName: 'Risk',
    iconClass: 'fa-exclamation-circle',
    field: 'CtmRiskProductByDebtorList',
    endpoint: 'DebtorProducts',
    path: 'product/risk',
    productFamily: constants.PRODUCT_FAMILY.PRODUCTS
  },
  HotelRankings: {
    displayName: 'Hotel Rankings',
    iconClass: 'fa-hotel',
    field: 'HotelRankingsSvelte',
    endpoint: '',
    path: 'hotel-rankings',
    productFamily: constants.PRODUCT_FAMILY.HOTEL
  }
}


// WEBPACK FOOTER //
// ./src/config/siteStructureConfig.js